//获取权限
export function getCurrentAuthority() {
  return [window.sessionStorage.getItem("current")];
}

export function setCurrentAuthority(current) {
  window.sessionStorage.setItem(
    "current",
    current === "管理员" ? "admin" : "common",
  );
}

//校验权限
export function check(authority) {
  const current = getCurrentAuthority();
  return current.some((item) => authority.includes(item));
}

//判断是否登录  获取到权限且权限不等于guest即表示已登录
export function isLogin() {
  const current = getCurrentAuthority();
  return current && current[0] !== "guest";
}
